import { useCallback, useEffect, useState } from 'react'
import { useClosingReqContext } from '../../../context'
import { setActiveRequirementActionCreator } from '../../../state'
import { getOpportunities, getOpportunityDetail } from '@user/store/opportunity'
import { useAppDispatch } from '@user/store/hooks'
import { setSelectedTemplate } from '@user/store/agreements'
import { ENTITY_TYPES } from '@sales-center/common'

type Props = {
  entityId?: number
  entityType?: ENTITY_TYPES
  formPacketEnabled: boolean
  createDrawerOpen: boolean
  setCreateDrawerOpen: (open: boolean) => void
}

export function useHandlers(props: Props) {
  const {
    entityId,
    entityType,
    formPacketEnabled,
    createDrawerOpen,
    setCreateDrawerOpen,
  } = props
  const [, dispatch] = useClosingReqContext()
  const storeDispatch = useAppDispatch()

  const [viewDrawerOpen, setViewDrawerOpen] = useState<boolean>(false)
  const [cancelPopupOpen, setCancelPopupOpen] = useState<boolean>(false)
  const [createLocationDrawerOpen, setCreateLocationDrawerOpen] =
    useState<boolean>(false)

  useEffect(() => {
    if (!createDrawerOpen) {
      storeDispatch(
        setSelectedTemplate({
          isLoading: false,
          template: null,
        }),
      )
    }
  }, [createDrawerOpen, storeDispatch])

  const openViewDrawer = useCallback(() => {
    setViewDrawerOpen(true)
    dispatch(setActiveRequirementActionCreator('agreement'))
  }, [dispatch])

  const closeViewDrawer = useCallback(() => {
    setViewDrawerOpen(false)
    dispatch(setActiveRequirementActionCreator(undefined))
  }, [dispatch])

  const openCreateServiceDrawer = useCallback(() => {
    setCreateLocationDrawerOpen(true)
  }, [])

  const closeCreateServiceDrawer = useCallback(() => {
    setCreateLocationDrawerOpen(false)
  }, [])

  const handleCancel = useCallback(() => {
    setCreateDrawerOpen(false)
    setCancelPopupOpen(false)
    if (entityType === ENTITY_TYPES.Opportunity) {
      storeDispatch(getOpportunities())
      if (entityId) {
        storeDispatch(getOpportunityDetail(entityId))
      }
    }

    dispatch(setActiveRequirementActionCreator(undefined))
  }, [setCreateDrawerOpen, entityType, dispatch, storeDispatch, entityId])

  const hideCancelDialog = useCallback(() => {
    setCancelPopupOpen(false)
  }, [])

  const closeCreateDrawer = useCallback(() => {
    if (formPacketEnabled) {
      setCancelPopupOpen(true)
    } else {
      handleCancel()
    }
  }, [formPacketEnabled, handleCancel])

  const onCloseFormManager = useCallback(() => {
    handleCancel()
  }, [handleCancel])

  return {
    viewDrawerOpen,
    cancelPopupOpen,
    openViewDrawer,
    closeViewDrawer,
    closeCreateDrawer,
    createLocationDrawerOpen,
    openCreateServiceDrawer,
    closeCreateServiceDrawer,
    hideCancelDialog,
    handleCancel,
    onCloseFormManager,
  }
}
